import { useCallback } from 'react'

import { useLocalization } from '../localization'
import type { SoilSurveyLegendEntry } from './FieldMap/soil-survey'

export const useSoilSurveyEntryLabel = () => {
  const { t } = useLocalization()

  return useCallback(
    (entry: SoilSurveyLegendEntry): string => {
      switch (entry.kind) {
        case 'SoilType':
          return entry.name
        case 'DrainageClass':
          return t(($) => $.map.terrain.drainageClasses[entry.drainageClass])
        case 'Unrated':
          return t(($) => $.map.terrain.notRated)
      }
    },
    [t]
  )
}
